// eslint-disable-next-line @typescript-eslint/no-var-requires
const { io } = require('socket.io-client');

const socketsURI = process.env.NEXT_PUBLIC_SOCKETS || 'localhost:5040';

const socket = io(socketsURI, {
  transports: ['websocket'],
  autoConnect: false,
});

socket.on('connect_error', (err) => {
  // eslint-disable-next-line no-console
  console.error(err);
});

export default socket;
